import React from 'react'
import { Typography } from 'antd'

const BrokerageTabTitle = ({ text, icon }) => {
  return (
    <Typography.Title level={5} type={'secondary'}>
      {icon} {text}
    </Typography.Title>
  )
}

export default BrokerageTabTitle
